import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Search from '../search/Search.jsx';
import TreeSelectionList from './tree-selection-list/TreeSelectionList.jsx';
import OutsideClickHandler from 'Components/OutsideClickHandler';
import SearchIcon from 'Components/icons/SearchIcon';
import './TreeView.scss';

const TreeView = ({ searchTerm, dataList, onChange, extraClass, placeholder, title, visible, noBorder, onClick, handleOutsideClick, handleChange, handleHeaderCheckbox, toggleCollapse }) => {
  const autocompleteClass = classnames(noBorder ? 'autocomplete_noborder' : 'tree-view-autocomplete', {
    [extraClass]: extraClass,
  });
  return (
    <OutsideClickHandler
      onClickOutside={handleOutsideClick}
    >
      <div className={autocompleteClass} >
        {title !== '' &&
          <div className="autocomplete__title">
            {title}
          </div>
        }
        <div role='button' className="tree-view-srch-mngr" onClick={onClick}>
          <SearchIcon isTreeView={true}/>
          <Search
            filterText={searchTerm}
            onChange={onChange}
            placeholder={placeholder}
           
          />
        </div>
        <TreeSelectionList
          dataList={dataList}
          handleHeaderCheckbox={handleHeaderCheckbox}
          visible={visible}
          searchTerm={searchTerm}
          extraClass=''
          handleChange={handleChange}
          toggleCollapse={toggleCollapse}
        />
      </div>
    </OutsideClickHandler>
  );
};

TreeView.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  dataList: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  extraClass: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  visible: PropTypes.bool,
  onFocus: PropTypes.func
};

TreeView.defaultProps = {
  title: '',
  extraClass: '',
  placeholder: '',
  searchTerm: '',
  visible: false
};

export default TreeView;
